import classNames from "classnames";

import AscSelectInput from "../../../AscInputFields/AscSelectInput/AscSelectInput";
import AscRichTextEditor from "../../../AscRichTextEditor/AscRichTextEditor";

import styles from "./AscChallenge.module.scss";
import { AdminChallenge } from "@ascendnow/shared";
import { useAscAddModuleContentForm } from "../useAscAddModuleContentForm";

export interface AscChallengeProps {
  className?: string;
  challenges?: AdminChallenge[];
}

function AscChallenge({ className, challenges }: AscChallengeProps) {
  const formik = useAscAddModuleContentForm();

  return (
    <div className={classNames(styles.ground, className)}>
      <div className={styles.form}>
        <label className={styles.fieldLabel} htmlFor="challengeId">
          Select from list of challenges
        </label>
        <AscSelectInput
          className={classNames(styles.inputField, {
            [styles.errorInput]:
              formik.errors.challengeId && formik.touched.challengeId,
          })}
          id="challengeId"
          name="challengeId"
          fullWidth={true}
          placeholder="Select challenge"
          onChange={(val) => formik.setFieldValue("challengeId", val)}
          onBlur={() => formik.setFieldTouched("challengeId", true)}
          value={formik.values.challengeId}
        >
          {challenges?.map((challenge) => (
            <AscSelectInput.Option
              key={challenge.id}
              value={challenge.id}
              label={challenge.title}
            />
          ))}
        </AscSelectInput>

        <label className={styles.fieldLabel} htmlFor="chllengeDesc">
          Description
        </label>
        <div className={styles.textEditorGround}>
          <AscRichTextEditor
            editable={true}
            initialInferValue={formik.values.chllengeDesc}
            onJsonChange={(value) => {
              formik.setFieldTouched(
                "chllengeDesc",
                value !== formik.values.chllengeDesc
              );
              formik.setFieldValue("chllengeDesc", value);
            }}
            className={styles.richTextEditor}
            inputWrapperClassname={styles.richTextEditorInput}
          />
        </div>
      </div>
    </div>
  );
}

export default AscChallenge;
